import { render } from "./TheFooter.vue?vue&type=template&id=6b93da95&scoped=true&lang=pug&bindings={\"lang\":\"setup\",\"langs\":\"setup\",\"company\":\"setup\",\"contacts\":\"setup\",\"address\":\"setup\",\"language\":\"setup\",\"changeLang\":\"setup\",\"develop\":\"setup\"}"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=6b93da95&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b93da95"

export default script